import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { updateDocument } from "astrid-firestore/src/helpers";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import useProducerTypeOptions from "../../../../organizations/hooks/useProducerTypeOptions";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function ProducerSettings({ producer }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		defaultValues: {
			producerType: producer.producerType || "standard",
			languageOptions: producer.languageOptions || [],
		},
		onSubmit: (data) => {
			return updateDocument(producer.ref, data);
		},
	});

	const producerTypeOptions = useProducerTypeOptions();

	const { error, formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{t("settings", "Settings")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Group widths="equal">
							<Form.Select
								name="producerType"
								label={t("producerType", "Producer type")}
								options={producerTypeOptions}
							/>
							<Form.LanguageSelect name="languageOptions" label={t("languageOptions")} multiple />
						</Form.Group>
					</Form>

					{error && <ErrorMessage error={error} />}
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
